export default {"src":"/_next/static/media/bcpt.c82597fc.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};